import styled, { css } from 'styled-components';


export const DivDefaultModal = styled.div`

    position: fixed;
    top: 0;
    left: 0;
    background: #00000065;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    p,
    h2 {
      margin: 0;
    }

`;

export const DivModalContent = styled.div`
    background: #fff;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 32px 16px;
    max-width: 480px;
    max-height: 460px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    overflow-y: auto;
`;

export const ModalContentTitle = styled.h2`
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    color: #005FAE;
`;

export const ModalDetail = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const ModalDetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-bottom: 1px solid#4D4C4D;
    padding-bottom: 2px;
    h2 {
        font-size: 14px;
        line-height: 24px;
        font-weight: 600;
        color: #4D4C4D;
    }
`;

export const ModalDetailContainerDebt = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4D4C4D;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
`;

export const ModalButton = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 8px;
    button {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
        border: none;
        background-color: #F58220;
        color: #fff;
        padding: 14px 20px;
        border-radius: 12px;
        transition: filter 0.2s;
        svg {
            color: #F58220;
            background-color: #fff;
            border-radius: 50%;
        }
        &:hover {
            filter: brightness(0.8);
        }
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    /* margin: 0 auto; */
    overflow-x: hidden;
    @media (max-width: 1024px) {
        height: auto;
        margin-top: 56px;
        flex-direction: column;
    }

`;
export const Content = styled.div`
     display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    margin: 0 auto;
    padding: 48px;
    z-index: 0;
    @media (max-width: 1024px) {
        position: relative !important;
        width: 100%;
        padding: 32px 16px 0;
        >div {
            box-shadow: none;
            border-radius: 0px;
            padding: 0px;
            margin: 0;
            max-width: 100%;
        }
    }
    >div {
        background: #FFFFFF;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
        border-radius: 12px;
        padding: 24px;
        max-width: 984px;
        margin: 0 auto;
        width: 100%;
    }
`;
export const ContentTitle = styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
        p {
            margin: 0;
        }
        >:first-child {
            color: #005FAE;
            font-size: 18px;
            line-height: 27px;
            font-weight: 400;
        }
        >:nth-child(2) {
            color: #4D4C4D;
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            span {
                color: #005FAE;
                font-weight: 600;
            }
        }
        @media (max-width: 1024px) {
            >:nth-child(2) {
                display: flex;
                flex-direction: column;
                span {
                    margin-top: 8px;
                }
            }
        }
`;
export const ContentDetail = styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
        p {
            margin: 0;
            font-size: 14px;
            line-height: 18px;
            color: #4D4C4D;
        }
        h4 {
            font-size: 14px;
            line-height: 21px;
            font-weight: 400;
            margin: 0;
            margin-bottom: 8px;
        }
        >:first-child {
            h4 {
                color: #005FAE;
            }
        }
        >:nth-child(2) {
            h4 {
                color: #F58220;
            }
        }
        @media (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            margin-bottom: 24px;
            h4 {
                font-size: 16px;
                line-height: 24px;
                margin-bottom: 16px;
            }
        }
`;
export const ContentContact = styled.div`
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 16px;
        @media (max-width: 1024px) {
            display: none;
        }
`;
export const ContentContactTitle = styled.div`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 24px;
        h2 {
            font-size: 18px;
            line-height: 27px;
            font-weight: 600;
            color: #4D4C4D;
            margin: 0;
        }
        div {
            display: flex;
            align-items: center;
            gap: 24px;
            svg {
                color: #F58220;
                height: 27px;
                width: auto;
            }
        }
        @media (max-width: 1024px) {
            display: none;
        }
`;
export const ContentContactDetail = styled.div`
        display: flex;
        align-items: center;
        gap: 24px;
        font-size: 14px;
        line-height: 21px;
        color: #4D4C4D;
        p {
            margin: 0;
            font-weight: 600;
        }
        span {
            font-weight: 400;
        }
        @media (max-width: 1024px) {
            display: none;
        }
`;


export const Summary = styled.div`
    background: #fff;
    width: 30%;
    height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 24px;
    /* width: 100%; */
    /* height: 100%; */
    max-width: 380px;
    padding: 48px 0px;
    p {
        margin: 0;
    }
    >p {
        color: #4D4C4D;
        font-size: 14px;
        line-height: 21px;
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        span {
            margin-top: 4px;
            font-size: 10px;
            line-height: 15px;
        }
    }
    @media (max-width: 1024px) {
        width: 100%;
        max-width: 100%;
        margin-top: 10px;
        padding: 32px 0px;
        height: auto;
        p {
            margin: 0;
        }
        >p {
            color: #4D4C4D;
            font-size: 14px;
            line-height: 21px;
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            span {
                margin-top: 4px;
                font-size: 10px;
                line-height: 15px;
            }
        }
    }
`;
export const SummaryOrder = styled.div`
        display: flex;
        flex-direction: column;
        font-size: 16px;
        line-height: 24px;
        color: #4D4C4D;
        padding: 0 16px;
        p {
            font-weight: 400;
            margin-bottom: 8px;
            span {
                font-weight: 600;
            }
        }
        button {
            margin-top: 24px;
            padding: 0;
            display: flex;
            align-items: center;
            color: #F58220;
            border: none;
            background: inherit;
            text-align: left;
            text-decoration: underline;
            cursor: pointer;
            transition: color 0.2s;
            &:hover {
                color: #005FAE;
            }
        }
        @media (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            font-size: 16px;
            line-height: 24px;
            color: #4D4C4D;
            padding: 0 16px;
            p {
                font-weight: 400;
                margin-bottom: 8px;
                span {
                    font-weight: 600;
                }
            }
            button {
                margin-top: 24px;
                padding: 0;
                display: flex;
                align-items: center;
                color: #F58220;
                border: none;
                background: inherit;
                text-align: left;
                text-decoration: underline;
                cursor: pointer;
                transition: color 0.2s;
                &:hover {
                    color: #005FAE;
                }
            }
        }
`;
export const SummaryInstallment = styled.div`
        display: flex;
        justify-content: space-between;
        padding: 16px;
        background: #005FAE;
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: #fff;
        span {
            color: #F58220;
            font-weight: 700;
        }
        @media (max-width: 1024px) {
            display: flex;
            justify-content: space-between;
            padding: 16px;
            background: #005FAE;
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            color: #fff;
            span {
                color: #F58220;
                font-weight: 700;
            }
        }
`;
export const SummaryDebts = styled.div`
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        >p {
            color: #807E80;
            font-size: 14px;
            line-height: 21px;
            font-weight: 400;
        }
        >div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 8px;
            border-bottom: 1px solid #F58220;
            color: #4D4C4D;
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
        }
        @media (max-width: 1024px) {
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            gap: 16px;
            >p {
                color: #807E80;
                font-size: 14px;
                line-height: 21px;
                font-weight: 400;
            }
            div {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 8px;
                border-bottom: 1px solid #F58220;
                color: #4D4C4D;
                font-size: 16px;
                line-height: 24px;
                font-weight: 400;
            }
        }
`;
